var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoZoom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #003189;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery_icon_zoom",
    "data-name": "gallery icon zoom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7012-2",
    "data-name": "Path 7012-2",
    className: "cls-1",
    d: "m31.5,0C14.1,0,0,14.1,0,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5S48.9,0,31.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7013",
    "data-name": "Path 7013",
    className: "cls-2",
    d: "m27.9,42.95c-.26-.27-.63-.41-1.01-.38h-5.92v-5.81c0-.11,0-.21,0-.32-.02-.49-.34-.91-.8-1.06-.48-.2-1.03-.09-1.4.26-.27.26-.41.63-.38,1.01v5.92h0v2.58h8.39c.11,0,.21,0,.32,0,.49-.02.91-.34,1.06-.8.2-.48.09-1.03-.26-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7014",
    "data-name": "Path 7014",
    className: "cls-2",
    d: "m44.61,20.43v-2.58h-8.39c-.11,0-.21,0-.32,0-.49.02-.91.34-1.06.8-.2.48-.09,1.03.26,1.4.26.27.63.41,1.01.38h8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7015",
    "data-name": "Path 7015",
    className: "cls-2",
    d: "m44.6,17.84h-2.58v8.39c0,.11,0,.21,0,.32.02.49.34.91.8,1.06.48.2,1.03.09,1.4-.26.27-.26.41-.63.38-1.01v-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7016",
    "data-name": "Path 7016",
    className: "cls-2",
    d: "m20.85,17.97h-2.58v8.39c0,.11,0,.21,0,.32.02.49.34.91.8,1.06.48.2,1.03.09,1.4-.26.27-.26.41-.63.38-1.01v-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7017",
    "data-name": "Path 7017",
    className: "cls-2",
    d: "m18.27,17.97v2.58h8.39c.11,0,.21,0,.32,0,.49-.02.91-.34,1.06-.8.2-.48.09-1.03-.26-1.4-.26-.27-.63-.41-1.01-.38h-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7018",
    "data-name": "Path 7018",
    className: "cls-2",
    d: "m42.15,45.04h2.58v-8.39c0-.11,0-.21,0-.32-.02-.49-.34-.91-.8-1.06-.48-.2-1.03-.09-1.4.26-.27.26-.41.63-.38,1.01v8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7019",
    "data-name": "Path 7019",
    className: "cls-2",
    d: "m44.73,45.03v-2.58h-8.39c-.11,0-.21,0-.32,0-.49.02-.91.34-1.06.8-.2.48-.09,1.03.26,1.4.26.27.63.41,1.01.38h8.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoZoom1);
export default __webpack_public_path__ + "static/media/ico-zoom-1.bc815f91131531ebea270cd7cac29e72.svg";
export { ForwardRef as ReactComponent };